import { Component, Input, OnInit } from '@angular/core';
import { EChartsOption } from 'echarts';
import { BarChartDataset } from '../models';

@Component({
    selector: 'app-stat-barchart',
    templateUrl: './stat-barchart.component.html',
    styleUrls: ['./stat-barchart.component.scss'],
    standalone: false
})
export class StatBarchartComponent implements OnInit {
  @Input() chartData!: BarChartDataset[];
  @Input() titleArray!: string[];
  @Input() colorArray?: string[];
  @Input() scrollableLegend?: boolean;
  @Input() showTooltip?: boolean;

  options!: EChartsOption;

  ngOnInit(): void {
    this.options = {
      legend: {},
      color: this.colorArray,
      xAxis: {
        data: this.titleArray,
      },
      yAxis: {},
      series: this.chartData as EChartsOption['series'],
    };

    if (this.scrollableLegend) {
      this.options = {
        ...this.options,
        legend: { type: 'scroll', show: true },
      };
    }

    if (this.showTooltip) {
      this.options = { ...this.options, tooltip: { show: true } };
    }
  }
}
